import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithLicenseAclEntries = { licenseAclEntries: FilterState };

const licenseAclEntriesSlice = createSlice({
    name: 'licenseAclEntries',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default licenseAclEntriesSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = licenseAclEntriesSlice.actions;
export const selectFilters = (state: StateWithLicenseAclEntries) => state.licenseAclEntries.filters;
